import { useContext } from "react";
import { BentoVisit } from "@/components/ui/box-visit-context";
import type { VisitAddress } from "@/components/ui/box.schema";
import { HistoryVisitOrigin } from "./history-visit-origin";

export function HistoryVisitButton({ address, box, children }: { address: VisitAddress; box?: string; children: React.ReactNode }) {
  const host = useContext(BentoVisit);
  const parent = useContext(HistoryVisitOrigin);
  const origin = box ?? parent;
  return <button type="button" data-act="visit" disabled={!host || !origin} className="text-ui font-semibold text-primary hover:underline" onClick={() => origin && host?.visit(address, { box: origin })}>{children}</button>;
}
